// DB OrganizationText SectionName constants.
// Use these as the translationKey prop in InlineTranslationEdit.
// Generated from tlffs-dev-v2-db OrganizationText defaults.

// ── About ───────────────────────────────────────────────────────
export const AboutAAA = 'AboutAAA';
export const AboutBannerLogoEnabled = 'AboutBannerLogoEnabled';
export const AboutBannerLogoUrl = 'AboutBannerLogoUrl';
export const AboutBannerSlideList = 'AboutBannerSlideList';
export const AboutBodySlideList = 'AboutBodySlideList';
export const AboutFullBodySlideList = 'AboutFullBodySlideList';
export const AboutFullPageEnabled = 'AboutFullPageEnabled';
export const AboutFullPageSlidesEnabled = 'AboutFullPageSlidesEnabled';
export const AboutFullPageText = 'AboutFullPageText';
export const AboutFullPageTitle = 'AboutFullPageTitle';
export const AboutPageSlidesEnabled = 'AboutPageSlidesEnabled';
export const AboutTitleEnabled = 'AboutTitleEnabled';
export const AboutTitleTitle = 'AboutTitleTitle';

// ── BonusDraws ─────────────────────────────────────────────────
export const BonusDrawsTitle = 'BonusDrawsTitle';
export const BonusDrawsSubtitle = 'BonusDrawsSubtitle';
export const BonusDrawsTickets = 'BonusDrawsTickets';
export const BonusDrawsEmpty = 'BonusDrawsEmpty';
export const BonusDrawsSold = 'BonusDrawsSold';
export const BonusDrawsDefaultTitle = 'BonusDrawsDefaultTitle';
export const BonusDrawsDateTBD = 'BonusDrawsDateTBD';
export const BonusDrawsCardFallback = 'BonusDrawsCardFallback';

// ── ChaseTheAce ─────────────────────────────────────────────────
export const CTA1CardSuitClubs = 'CTA1CardSuitClubs';
export const CTA1CardSuitDiamonds = 'CTA1CardSuitDiamonds';
export const CTA1CardSuitHearts = 'CTA1CardSuitHearts';
export const CTA1CardSuitSpades = 'CTA1CardSuitSpades';
export const CTA1CurrentOdds = 'CTA1CurrentOdds';
export const CTA1FinalCtaWithOnly = 'CTA1FinalCtaWithOnly';
export const CTA1ShufflingDeck = 'CTA1ShufflingDeck';
export const CTA1WinThe = 'CTA1WinThe';
export const CTA6CardSuitClubs = 'CTA6CardSuitClubs';
export const CTA6CardSuitDiamonds = 'CTA6CardSuitDiamonds';
export const CTA6CardSuitHearts = 'CTA6CardSuitHearts';
export const CTA6CardSuitSpades = 'CTA6CardSuitSpades';
export const CTA6FinalCtaWithOnly = 'CTA6FinalCtaWithOnly';
export const CTA7CardSuitClubs = 'CTA7CardSuitClubs';
export const CTA7CardSuitDiamonds = 'CTA7CardSuitDiamonds';
export const CTA7CardSuitHearts = 'CTA7CardSuitHearts';
export const CTA7CardSuitSpades = 'CTA7CardSuitSpades';
export const CTA7FinalCtaWithOnly = 'CTA7FinalCtaWithOnly';
export const CTA7SeeWhosWinning = 'CTA7SeeWhosWinning';
export const CTAV2Loading = 'CTAV2Loading';
export const CTAV2NoWinnersYet = 'CTAV2NoWinnersYet';

// ── Charity ───────────────────────────────────────────────────────
export const CharityAceOfHeartsCTA = 'CharityAceOfHeartsCTA';
export const CharityAceOfHeartsTitle = 'CharityAceOfHeartsTitle';
export const CharityCenterSquareCTA = 'CharityCenterSquareCTA';
export const CharityCenterSquareSupports = 'CharityCenterSquareSupports';
export const CharityCenterSquareTitle = 'CharityCenterSquareTitle';
export const CharityGiftBoxCTA = 'CharityGiftBoxCTA';
export const CharityGiftBoxImpact = 'CharityGiftBoxImpact';
export const CharityGiftBoxTitle = 'CharityGiftBoxTitle';
export const CharityGrowingImpactCTA = 'CharityGrowingImpactCTA';
export const CharityGrowingImpactProgress = 'CharityGrowingImpactProgress';
export const CharityGrowingImpactSubtext = 'CharityGrowingImpactSubtext';
export const CharityGrowingImpactTitle = 'CharityGrowingImpactTitle';
export const CharityGrowingImpactTotal = 'CharityGrowingImpactTotal';
export const CharityGrowingImpactWeek = 'CharityGrowingImpactWeek';
export const CharitySplitPotCharitysHalf = 'CharitySplitPotCharitysHalf';
export const CharitySplitPotLearnMore = 'CharitySplitPotLearnMore';
export const CharitySplitPotTitle = 'CharitySplitPotTitle';
export const CharitySplitPotWinnersHalf = 'CharitySplitPotWinnersHalf';
export const CharitySurvivorShieldChampion = 'CharitySurvivorShieldChampion';
export const CharitySurvivorShieldChampionBadge = 'CharitySurvivorShieldChampionBadge';
export const CharitySurvivorShieldCTA = 'CharitySurvivorShieldCTA';
export const CharitySurvivorShieldImpact = 'CharitySurvivorShieldImpact';
export const CharitySurvivorShieldTitle = 'CharitySurvivorShieldTitle';

// ── Checkout ───────────────────────────────────────────────────────
export const CheckoutAllFieldsError = 'CheckoutAllFieldsError';
export const CheckoutBillingCheckError = 'CheckoutBillingCheckError';
export const CheckoutBillingCity = 'CheckoutBillingCity';
export const CheckoutBillingCityError = 'CheckoutBillingCityError';
export const CheckoutBillingCountry = 'CheckoutBillingCountry';
export const CheckoutBillingCountryError = 'CheckoutBillingCountryError';
export const CheckoutBillingFirstName = 'CheckoutBillingFirstName';
export const CheckoutBillingFirstNameError = 'CheckoutBillingFirstNameError';
export const CheckoutBillingLastName = 'CheckoutBillingLastName';
export const CheckoutBillingLastNameError = 'CheckoutBillingLastNameError';
export const CheckoutBillingPhone = 'CheckoutBillingPhone';
export const CheckoutBillingPhoneError = 'CheckoutBillingPhoneError';
export const CheckoutBillingPostalCode = 'CheckoutBillingPostalCode';
export const CheckoutBillingPostalCodeError = 'CheckoutBillingPostalCodeError';
export const CheckoutBillingProvince = 'CheckoutBillingProvince';
export const CheckoutBillingProvinceError = 'CheckoutBillingProvinceError';
export const CheckoutBillingStreetAddress = 'CheckoutBillingStreetAddress';
export const CheckoutBillingStreetAddressError = 'CheckoutBillingStreetAddressError';
export const CheckoutBillingTitle = 'CheckoutBillingTitle';
export const CheckoutCartDeal = 'CheckoutCartDeal';
export const CheckoutCartEnvelope = 'CheckoutCartEnvelope';
export const CheckoutCartTicketCost = 'CheckoutCartTicketCost';
export const CheckoutCartTicketDrawDate = 'CheckoutCartTicketDrawDate';
export const CheckoutCartTicketNewNumber = 'CheckoutCartTicketNewNumber';
export const CheckoutCartTicketNumber = 'CheckoutCartTicketNumber';
export const CheckoutCartTicketRenewal = 'CheckoutCartTicketRenewal';
export const CheckoutCartTicketType = 'CheckoutCartTicketType';
export const CheckoutCartTitle = 'CheckoutCartTitle';
export const CheckoutClear = 'CheckoutClear';
export const CheckoutClearAll = 'CheckoutClearAll';
export const CheckoutContinue = 'CheckoutContinue';
export const CheckoutCopy = 'CheckoutCopy';
export const CheckoutDisclaimer = 'CheckoutDisclaimer';
export const CheckoutEdit = 'CheckoutEdit';
export const CheckoutLimitationsError = 'CheckoutLimitationsError';
export const CheckoutLocationCheckText1 = 'CheckoutLocationCheckText1';
export const CheckoutLocationCheckText2 = 'CheckoutLocationCheckText2';
export const CheckoutLocationCheckText3 = 'CheckoutLocationCheckText3';
export const CheckoutNoEnvelopeError = 'CheckoutNoEnvelopeError';
export const CheckoutNoItemsError = 'CheckoutNoItemsError';
export const CheckoutNone = 'CheckoutNone';
export const CheckoutOptionSelection = 'CheckoutOptionSelection';
export const CheckoutOrderDraws = 'CheckoutOrderDraws';
export const CheckoutOrderPayNowButton = 'CheckoutOrderPayNowButton';
export const CheckoutOrderPricePerTicket = 'CheckoutOrderPricePerTicket';
export const CheckoutOrderTickets = 'CheckoutOrderTickets';
export const CheckoutOrderTitle = 'CheckoutOrderTitle';
export const CheckoutOrderTotal = 'CheckoutOrderTotal';
export const CheckoutPaymentApril = 'CheckoutPaymentApril';
export const CheckoutPaymentAugust = 'CheckoutPaymentAugust';
export const CheckoutPaymentCardNumber = 'CheckoutPaymentCardNumber';
export const CheckoutPaymentCardNumberError = 'CheckoutPaymentCardNumberError';
export const CheckoutPaymentCVV = 'CheckoutPaymentCVV';
export const CheckoutPaymentCVVError = 'CheckoutPaymentCVVError';
export const CheckoutPaymentDecember = 'CheckoutPaymentDecember';
export const CheckoutPaymentExpiryMonth = 'CheckoutPaymentExpiryMonth';
export const CheckoutPaymentExpiryMonthError = 'CheckoutPaymentExpiryMonthError';
export const CheckoutPaymentExpiryYear = 'CheckoutPaymentExpiryYear';
export const CheckoutPaymentExpiryYearError = 'CheckoutPaymentExpiryYearError';
export const CheckoutPaymentFebruary = 'CheckoutPaymentFebruary';
export const CheckoutPaymentJanuary = 'CheckoutPaymentJanuary';
export const CheckoutPaymentJuly = 'CheckoutPaymentJuly';
export const CheckoutPaymentJune = 'CheckoutPaymentJune';
export const CheckoutPaymentMarch = 'CheckoutPaymentMarch';
export const CheckoutPaymentMay = 'CheckoutPaymentMay';
export const CheckoutPaymentNameOnCard = 'CheckoutPaymentNameOnCard';
export const CheckoutPaymentNameOnCardError = 'CheckoutPaymentNameOnCardError';
export const CheckoutPaymentNovember = 'CheckoutPaymentNovember';
export const CheckoutPaymentOctober = 'CheckoutPaymentOctober';
export const CheckoutPaymentOr = 'CheckoutPaymentOr';
export const CheckoutPaymentSeptember = 'CheckoutPaymentSeptember';
export const CheckoutPaymentTitle = 'CheckoutPaymentTitle';
export const CheckoutPrivacyPolicy = 'CheckoutPrivacyPolicy';
export const CheckoutPrivacyPre = 'CheckoutPrivacyPre';
export const CheckoutPrivacyStrong = 'CheckoutPrivacyStrong';
export const CheckoutProcessing = 'CheckoutProcessing';
export const CheckoutProcessingError = 'CheckoutProcessingError';
export const CheckoutRequired = 'CheckoutRequired';
export const CheckoutSkip = 'CheckoutSkip';
export const CheckoutStep1 = 'CheckoutStep1';
export const CheckoutStep1Header = 'CheckoutStep1Header';
export const CheckoutStep2PayHeader = 'CheckoutStep2PayHeader';
export const CheckoutStep2TermsHeader = 'CheckoutStep2TermsHeader';
export const CheckoutStep3Header = 'CheckoutStep3Header';
export const CheckoutStripe = 'CheckoutStripe';
export const CheckoutStripePre = 'CheckoutStripePre';
export const CheckoutTermsAndConditions = 'CheckoutTermsAndConditions';
export const CheckoutTermsText1 = 'CheckoutTermsText1';
export const CheckoutTermsText2 = 'CheckoutTermsText2';
export const CheckoutTestCardNumber = 'CheckoutTestCardNumber';
export const CheckoutTestCardNumberTitle = 'CheckoutTestCardNumberTitle';
export const CheckoutTestCVC = 'CheckoutTestCVC';
export const CheckoutTestCVCTitle = 'CheckoutTestCVCTitle';
export const CheckoutTestCVDTitle = 'CheckoutTestCVDTitle';
export const CheckoutTestExpiry = 'CheckoutTestExpiry';
export const CheckoutTestExpiryTitle = 'CheckoutTestExpiryTitle';
export const CheckoutTestModeDisclaimer = 'CheckoutTestModeDisclaimer';
export const CheckoutTestModeTitle = 'CheckoutTestModeTitle';
export const CheckoutTestMonerisExpiry = 'CheckoutTestMonerisExpiry';
export const CheckoutTitle = 'CheckoutTitle';
export const CheckoutViewLess = 'CheckoutViewLess';
export const CheckoutViewMore = 'CheckoutViewMore';
export const ChekoutStripe = 'ChekoutStripe';

// ── Closed ───────────────────────────────────────────────────────
export const ClosedCongratulations = 'ClosedCongratulations';
export const ClosedJackpot = 'ClosedJackpot';
export const ClosedNextDrawOpens = 'ClosedNextDrawOpens';
export const ClosedNoActiveDraws = 'ClosedNoActiveDraws';
export const ClosedPreDrawAuditText = 'ClosedPreDrawAuditText';
export const ClosedText = 'ClosedText';
export const ClosedTitle = 'ClosedTitle';
export const ClosedWhoWonOur = 'ClosedWhoWonOur';

// ── Contact ───────────────────────────────────────────────────────
export const ContactLeftColumnAddress = 'ContactLeftColumnAddress';
export const ContactLeftColumnEmail = 'ContactLeftColumnEmail';
export const ContactLeftColumnPhone = 'ContactLeftColumnPhone';
export const ContactLeftColumnText = 'ContactLeftColumnText';
export const ContactLeftColumnText1 = 'ContactLeftColumnText1';
export const ContactLeftColumnText2 = 'ContactLeftColumnText2';
export const ContactLeftColumnTitle = 'ContactLeftColumnTitle';
export const ContactLeftDisclaimer = 'ContactLeftDisclaimer';
export const ContactLeftOnBehalf = 'ContactLeftOnBehalf';
export const ContactLeftOperatedBy = 'ContactLeftOperatedBy';
export const ContactLeftTLFEmail = 'ContactLeftTLFEmail';
export const ContactLeftTLFEmailText = 'ContactLeftTLFEmailText';
export const ContactRightColumnText = 'ContactRightColumnText';
export const ContactRightColumnTitle = 'ContactRightColumnTitle';
export const ContactTitleText = 'ContactTitleText';
export const ContactFormLabelName = 'ContactFormLabelName';
export const ContactFormLabelEmail = 'ContactFormLabelEmail';
export const ContactFormLabelSubject = 'ContactFormLabelSubject';
export const ContactFormLabelMessage = 'ContactFormLabelMessage';
export const ContactFormButtonSend = 'ContactFormButtonSend';
export const ContactPhoneHours = 'ContactPhoneHours';
export const ContactAddressValue = 'ContactAddressValue';
export const ContactPhoneValue = 'ContactPhoneValue';
export const ContactEmailValue = 'ContactEmailValue';

// ── Display ───────────────────────────────────────────────────────
export const DisplayBackgroundImage = 'DisplayBackgroundImage';
export const DisplayPlayAt = 'DisplayPlayAt';
export const DisplaySecondaryPot = 'DisplaySecondaryPot';
export const DisplayTitle = 'DisplayTitle';
export const DisplayTitlePrizeDraw = 'DisplayTitlePrizeDraw';

// ── Draws ───────────────────────────────────────────────────────
export const DrawsButton = 'DrawsButton';
export const DrawsCurrentJackpot = 'DrawsCurrentJackpot';
export const DrawsFriday = 'DrawsFriday';
export const DrawsMonday = 'DrawsMonday';
export const DrawsSaturday = 'DrawsSaturday';
export const DrawsSunday = 'DrawsSunday';
export const DrawsThursday = 'DrawsThursday';
export const DrawsTitle = 'DrawsTitle';
export const DrawsTuesday = 'DrawsTuesday';
export const DrawsWednesday = 'DrawsWednesday';

// ── Email ───────────────────────────────────────────────────────
export const EmailUserRoleIsAdmin = 'EmailUserRoleIsAdmin';
export const EmailUserRoleIsBilling = 'EmailUserRoleIsBilling';
export const EmailUserRoleIsContentEditor = 'EmailUserRoleIsContentEditor';
export const EmailUserRoleIsKiosk = 'EmailUserRoleIsKiosk';
export const EmailUserRoleIsMarketing = 'EmailUserRoleIsMarketing';
export const EmailUserRoleIsRegulator = 'EmailUserRoleIsRegulator';
export const EmailUserRoleIsSalesAgent = 'EmailUserRoleIsSalesAgent';

// ── Error ───────────────────────────────────────────────────────
export const ErrorClosedNextDraw = 'ErrorClosedNextDraw';
export const ErrorClosedText = 'ErrorClosedText';
export const ErrorClosedTitle = 'ErrorClosedTitle';
export const ErrorConstruction = 'ErrorConstruction';
export const ErrorConstructionThankyou = 'ErrorConstructionThankyou';
export const ErrorContact = 'ErrorContact';
export const ErrorContactPost = 'ErrorContactPost';
export const ErrorContactPre = 'ErrorContactPre';
export const ErrorExclusionDisclaimerLink = 'ErrorExclusionDisclaimerLink';
export const ErrorExclusionDisclaimerPost = 'ErrorExclusionDisclaimerPost';
export const ErrorExclusionDisclaimerPre = 'ErrorExclusionDisclaimerPre';
export const ErrorExclusionText = 'ErrorExclusionText';
export const ErrorGeoblockAndroidStep1 = 'ErrorGeoblockAndroidStep1';
export const ErrorGeoblockAndroidStep2 = 'ErrorGeoblockAndroidStep2';
export const ErrorGeoblockAndroidStep3 = 'ErrorGeoblockAndroidStep3';
export const ErrorGeoblockAndroidStep4 = 'ErrorGeoblockAndroidStep4';
export const ErrorGeoblockAndroidStep5 = 'ErrorGeoblockAndroidStep5';
export const ErrorGeoblockAndroidStep6 = 'ErrorGeoblockAndroidStep6';
export const ErrorGeoblockChecking = 'ErrorGeoblockChecking';
export const ErrorGeoblockChromeStep1 = 'ErrorGeoblockChromeStep1';
export const ErrorGeoblockChromeStep2 = 'ErrorGeoblockChromeStep2';
export const ErrorGeoblockChromeStep3 = 'ErrorGeoblockChromeStep3';
export const ErrorGeoblockChromeStep4 = 'ErrorGeoblockChromeStep4';
export const ErrorGeoblockCity = 'ErrorGeoblockCity';
export const ErrorGeoblockCountryName = 'ErrorGeoblockCountryName';
export const ErrorGeoblockCurrentIP = 'ErrorGeoblockCurrentIP';
export const ErrorGeoblockDefaultStep1 = 'ErrorGeoblockDefaultStep1';
export const ErrorGeoblockDefaultStep2 = 'ErrorGeoblockDefaultStep2';
export const ErrorGeoblockDefaultStep3 = 'ErrorGeoblockDefaultStep3';
export const ErrorGeoblockDefaultStep4 = 'ErrorGeoblockDefaultStep4';
export const ErrorGeoblockEdgeStep1 = 'ErrorGeoblockEdgeStep1';
export const ErrorGeoblockEdgeStep2 = 'ErrorGeoblockEdgeStep2';
export const ErrorGeoblockEdgeStep3 = 'ErrorGeoblockEdgeStep3';
export const ErrorGeoblockEdgeStep4 = 'ErrorGeoblockEdgeStep4';
export const ErrorGeoblockEnableLocation = 'ErrorGeoblockEnableLocation';
export const ErrorGeoblockExplanation = 'ErrorGeoblockExplanation';
export const ErrorGeoblockFirefoxStep1 = 'ErrorGeoblockFirefoxStep1';
export const ErrorGeoblockFirefoxStep2 = 'ErrorGeoblockFirefoxStep2';
export const ErrorGeoblockFirefoxStep3 = 'ErrorGeoblockFirefoxStep3';
export const ErrorGeoblockFirefoxStep4 = 'ErrorGeoblockFirefoxStep4';
export const ErrorGeoblockFirefoxStep5 = 'ErrorGeoblockFirefoxStep5';
export const ErrorGeoblockHideInstructions = 'ErrorGeoblockHideInstructions';
export const ErrorGeoblockInformation = 'ErrorGeoblockInformation';
export const ErrorGeoblockIOSStep1 = 'ErrorGeoblockIOSStep1';
export const ErrorGeoblockIOSStep2 = 'ErrorGeoblockIOSStep2';
export const ErrorGeoblockIOSStep3 = 'ErrorGeoblockIOSStep3';
export const ErrorGeoblockIOSStep4 = 'ErrorGeoblockIOSStep4';
export const ErrorGeoblockIOSStep5 = 'ErrorGeoblockIOSStep5';
export const ErrorGeoblockIOSStep6 = 'ErrorGeoblockIOSStep6';
export const ErrorGeoblockIP = 'ErrorGeoblockIP';
export const ErrorGeoblockLocationDenied = 'ErrorGeoblockLocationDenied';
export const ErrorGeoblockPermissionDenied = 'ErrorGeoblockPermissionDenied';
export const ErrorGeoblockPostalCode = 'ErrorGeoblockPostalCode';
export const ErrorGeoblockRegionCode = 'ErrorGeoblockRegionCode';
export const ErrorGeoblockRegionName = 'ErrorGeoblockRegionName';
export const ErrorGeoblockRetryFailed = 'ErrorGeoblockRetryFailed';
export const ErrorGeoblockSafariStep1 = 'ErrorGeoblockSafariStep1';
export const ErrorGeoblockSafariStep2 = 'ErrorGeoblockSafariStep2';
export const ErrorGeoblockSafariStep3 = 'ErrorGeoblockSafariStep3';
export const ErrorGeoblockSafariStep4 = 'ErrorGeoblockSafariStep4';
export const ErrorGeoblockSafariStep5 = 'ErrorGeoblockSafariStep5';
export const ErrorGeoblockShowInstructions = 'ErrorGeoblockShowInstructions';
export const ErrorGeoblockStillBlocked = 'ErrorGeoblockStillBlocked';
export const ErrorGeoblockText = 'ErrorGeoblockText';
export const ErrorGeoblockTryAgain = 'ErrorGeoblockTryAgain';
export const ErrorGeofenceChromeIcon = 'ErrorGeofenceChromeIcon';
export const ErrorGeofenceChromeInstructions = 'ErrorGeofenceChromeInstructions';
export const ErrorGeofenceEdgeIcon = 'ErrorGeofenceEdgeIcon';
export const ErrorGeofenceEdgeInstructions = 'ErrorGeofenceEdgeInstructions';
export const ErrorGeofenceFirefoxIcon = 'ErrorGeofenceFirefoxIcon';
export const ErrorGeofenceFirefoxInstructions = 'ErrorGeofenceFirefoxInstructions';
export const ErrorGeofenceIEIcon = 'ErrorGeofenceIEIcon';
export const ErrorGeofenceIEInstructions = 'ErrorGeofenceIEInstructions';
export const ErrorGeofenceInstructions = 'ErrorGeofenceInstructions';
export const ErrorGeofenceMobileInstructions = 'ErrorGeofenceMobileInstructions';
export const ErrorGeofenceSafariIcon = 'ErrorGeofenceSafariIcon';
export const ErrorGeofenceSafariInstructions = 'ErrorGeofenceSafariInstructions';
export const ErrorGeofenceText = 'ErrorGeofenceText';
export const ErrorHomepage = 'ErrorHomepage';
export const ErrorHomepagePost = 'ErrorHomepagePost';
export const ErrorHomepagePre = 'ErrorHomepagePre';
export const ErrorList = 'ErrorList';
export const ErrorPayPalText = 'ErrorPayPalText';
export const ErrorPleaseTryAgain = 'ErrorPleaseTryAgain';
export const ErrorSubTitle = 'ErrorSubTitle';
export const ErrorTitle = 'ErrorTitle';

// ── Elimination ────────────────────────────────────────────────────
export const ElimStyle2_EliminatedOf = 'ElimStyle2_EliminatedOf';
export const ElimStyle2_Loading = 'ElimStyle2_Loading';
export const ElimStyle2_Milestone1000Remain = 'ElimStyle2_Milestone1000Remain';
export const ElimStyle2_MilestoneFinal100 = 'ElimStyle2_MilestoneFinal100';
export const ElimStyle2_MilestoneFirst1000 = 'ElimStyle2_MilestoneFirst1000';
export const ElimStyle2_MilestoneHalfway = 'ElimStyle2_MilestoneHalfway';

// ── FAQ ───────────────────────────────────────────────────────
export const ContactTitleEnabled = 'ContactTitleEnabled';
export const FAQGroupList = 'FAQGroupList';
export const FAQTitle = 'FAQTitle';
export const FAQHeaderTagline = 'FAQHeaderTagline';
export const FAQHeaderSubtitle = 'FAQHeaderSubtitle';
export const FAQCtaHeading = 'FAQCtaHeading';
export const FAQCtaSubtitle = 'FAQCtaSubtitle';
export const FAQCtaButtonText = 'FAQCtaButtonText';

// ── Footer ───────────────────────────────────────────────────────
export const FooterAbout = 'FooterAbout';
export const FooterAnalyticsEnabled = 'FooterAnalyticsEnabled';
export const FooterAnalyticsID = 'FooterAnalyticsID';
export const FooterContact = 'FooterContact';
export const FooterCopyright = 'FooterCopyright';
export const FooterDraws = 'FooterDraws';
export const FooterFAQ = 'FooterFAQ';
export const FooterHowToPlay = 'FooterHowToPlay';
export const FooterKGCComplaintsLinkText = 'FooterKGCComplaintsLinkText';
export const FooterKGCID = 'FooterKGCID';
export const FooterKGCLicenseComplaints = 'FooterKGCLicenseComplaints';
export const FooterKGCLicenseDisclaimer = 'FooterKGCLicenseDisclaimer';
export const FooterLogin = 'FooterLogin';
export const FooterLogout = 'FooterLogout';
export const FooterLotteryLicenseStatement = 'FooterLotteryLicenseStatement';
export const FooterMyTickets = 'FooterMyTickets';
export const FooterOperatedBy = 'FooterOperatedBy';
export const FooterOperatedByText1 = 'FooterOperatedByText1';
export const FooterOperatedByText2 = 'FooterOperatedByText2';
export const FooterOperatedByText3 = 'FooterOperatedByText3';
export const FooterPrivacy = 'FooterPrivacy';
export const FooterResponsibleGaming = 'FooterResponsibleGaming';
export const FooterSignUp = 'FooterSignUp';
export const FooterSnackbarCheckout = 'FooterSnackbarCheckout';
export const FooterSnackbarCheckoutPost = 'FooterSnackbarCheckoutPost';
export const FooterSnackbarCheckoutPre = 'FooterSnackbarCheckoutPre';
export const FooterSnackbarTicketsSold = 'FooterSnackbarTicketsSold';
export const FooterTerms = 'FooterTerms';
export const FooterWinners = 'FooterWinners';

// ── Header ───────────────────────────────────────────────────────
export const HeaderAbout = 'HeaderAbout';
export const HeaderBuyMore = 'HeaderBuyMore';
export const HeaderCartText = 'HeaderCartText';
export const HeaderDraws = 'HeaderDraws';
export const HeaderFAQ = 'HeaderFAQ';
export const HeaderHiName = 'HeaderHiName';
export const HeaderHome = 'HeaderHome';
export const HeaderHowToPlay = 'HeaderHowToPlay';
export const HeaderLogin = 'HeaderLogin';
export const HeaderLogout = 'HeaderLogout';
export const HeaderMenu = 'HeaderMenu';
export const HeaderMobileLanguageSelection = 'HeaderMobileLanguageSelection';
export const HeaderMyTickets = 'HeaderMyTickets';
export const HeaderOrderHistory = 'HeaderOrderHistory';
export const HeaderPlayNow = 'HeaderPlayNow';
export const HeaderSettings = 'HeaderSettings';
export const HeaderSignUp = 'HeaderSignUp';
export const HeaderWinners = 'HeaderWinners';

// ── Home ───────────────────────────────────────────────────────
export const HomeActualJackpotAmountText = 'HomeActualJackpotAmountText';
export const HomeActualJackpotExplanationText = 'HomeActualJackpotExplanationText';
export const HomeAdditionalDrawsCloseDate = 'HomeAdditionalDrawsCloseDate';
export const HomeAdditionalDrawsDrawDate = 'HomeAdditionalDrawsDrawDate';
export const HomeAdditionalDrawsIntroText = 'HomeAdditionalDrawsIntroText';
export const HomeAdditionalDrawsJackpotTextMany = 'HomeAdditionalDrawsJackpotTextMany';
export const HomeAdditionalDrawsJackpotTextOne = 'HomeAdditionalDrawsJackpotTextOne';
export const HomeAdditionalDrawsMoreDetails = 'HomeAdditionalDrawsMoreDetails';
export const HomeAdditionalDrawsOpeningDate = 'HomeAdditionalDrawsOpeningDate';
export const HomeAdditionalDrawsText1 = 'HomeAdditionalDrawsText1';
export const HomeAdditionalDrawsText2 = 'HomeAdditionalDrawsText2';
export const HomeAdditionalDrawsText3 = 'HomeAdditionalDrawsText3';
export const HomeAdditionalDrawsTicketLimitText1 = 'HomeAdditionalDrawsTicketLimitText1';
export const HomeAdditionalDrawsTicketLimitText2 = 'HomeAdditionalDrawsTicketLimitText2';
export const HomeAdditionalDrawsTitle = 'HomeAdditionalDrawsTitle';
export const HomeAdditionalHomeBlockText = 'HomeAdditionalHomeBlockText';
export const HomeAdditionalProceedsText = 'HomeAdditionalProceedsText';
export const HomeBannerSecondaryLogoEnabled = 'HomeBannerSecondaryLogoEnabled';
export const HomeBannerSecondaryLogoUrl = 'HomeBannerSecondaryLogoUrl';
export const HomeBannerText = 'HomeBannerText';
export const HomeBannerTextEnabled = 'HomeBannerTextEnabled';
export const HomeBannerTLFCredit = 'HomeBannerTLFCredit';
export const HomeBodySlideList = 'HomeBodySlideList';
export const HomeCTACardSelected = 'HomeCTACardSelected';
export const HomeCTACharityTextBottom = 'HomeCTACharityTextBottom';
export const HomeCTACharityTextTop = 'HomeCTACharityTextTop';
export const HomeCTAChooseCardBottom = 'HomeCTAChooseCardBottom';
export const HomeCTAChooseCardBottomPost = 'HomeCTAChooseCardBottomPost';
export const HomeCTAChooseCardBottomPre = 'HomeCTAChooseCardBottomPre';
export const HomeCTAChooseCardTop = 'HomeCTAChooseCardTop';
export const HomeCTADays = 'HomeCTADays';
export const HomeCTADisclaimer = 'HomeCTADisclaimer';
export const HomeCTADrawDate = 'HomeCTADrawDate';
export const HomeCTADrawing = 'HomeCTADrawing';
export const HomeCTADrawWaitingMessage = 'HomeCTADrawWaitingMessage';
export const HomeCTADrawWaitingTitle = 'HomeCTADrawWaitingTitle';
export const HomeCTAGame = 'HomeCTAGame';
export const HomeCTAHeader10 = 'HomeCTAHeader10';
export const HomeCTAHeader2 = 'HomeCTAHeader2';
export const HomeCTAHeader3 = 'HomeCTAHeader3';
export const HomeCTAHeader4 = 'HomeCTAHeader4';
export const HomeCTAHeader5 = 'HomeCTAHeader5';
export const HomeCTAHeader6 = 'HomeCTAHeader6';
export const HomeCTAHeader7 = 'HomeCTAHeader7';
export const HomeCTAHeader8 = 'HomeCTAHeader8';
export const HomeCTAHeader9 = 'HomeCTAHeader9';
export const HomeCTAHeaderAce = 'HomeCTAHeaderAce';
export const HomeCTAHeaderClubs = 'HomeCTAHeaderClubs';
export const HomeCTAHeaderDiamonds = 'HomeCTAHeaderDiamonds';
export const HomeCTAHeaderHearts = 'HomeCTAHeaderHearts';
export const HomeCTAHeaderJack = 'HomeCTAHeaderJack';
export const HomeCTAHeaderKing = 'HomeCTAHeaderKing';
export const HomeCTAHeaderPostText = 'HomeCTAHeaderPostText';
export const HomeCTAHeaderPreText = 'HomeCTAHeaderPreText';
export const HomeCTAHeaderQueen = 'HomeCTAHeaderQueen';
export const HomeCTAHeaderSpades = 'HomeCTAHeaderSpades';
export const HomeCTAHeaderText = 'HomeCTAHeaderText';
export const HomeCTAHours = 'HomeCTAHours';
export const HomeCTAHowToPlayAboutHeader = 'HomeCTAHowToPlayAboutHeader';
export const HomeCTAHowToPlayAboutText = 'HomeCTAHowToPlayAboutText';
export const HomeCTAHowToPlayAceText1 = 'HomeCTAHowToPlayAceText1';
export const HomeCTAHowToPlayAceText2 = 'HomeCTAHowToPlayAceText2';
export const HomeCTAHowToPlayAceTextMid = 'HomeCTAHowToPlayAceTextMid';
export const HomeCTAHowToPlayAceTextPre = 'HomeCTAHowToPlayAceTextPre';
export const HomeCTAHowToPlayAceTitle = 'HomeCTAHowToPlayAceTitle';
export const HomeCTAHowToPlayBuyText = 'HomeCTAHowToPlayBuyText';
export const HomeCTAHowToPlayBuyTextMid = 'HomeCTAHowToPlayBuyTextMid';
export const HomeCTAHowToPlayBuyTextOf = 'HomeCTAHowToPlayBuyTextOf';
export const HomeCTAHowToPlayBuyTextPost = 'HomeCTAHowToPlayBuyTextPost';
export const HomeCTAHowToPlayBuyTextPre = 'HomeCTAHowToPlayBuyTextPre';
export const HomeCTAHowToPlayBuyTitle = 'HomeCTAHowToPlayBuyTitle';
export const HomeCTAHowToPlayHeader = 'HomeCTAHowToPlayHeader';
export const HomeCTAHowToPlaySeeText1 = 'HomeCTAHowToPlaySeeText1';
export const HomeCTAHowToPlaySeeText2 = 'HomeCTAHowToPlaySeeText2';
export const HomeCTAHowToPlaySeeTitle = 'HomeCTAHowToPlaySeeTitle';
export const HomeCTAHowToPlaySelectText = 'HomeCTAHowToPlaySelectText';
export const HomeCTAHowToPlaySelectTextPost = 'HomeCTAHowToPlaySelectTextPost';
export const HomeCTAHowToPlaySelectTextPre = 'HomeCTAHowToPlaySelectTextPre';
export const HomeCTAHowToPlaySelectTitle = 'HomeCTAHowToPlaySelectTitle';
export const HomeCTAJackpotWon = 'HomeCTAJackpotWon';
export const HomeCTAMinutes = 'HomeCTAMinutes';
export const HomeCTASeconds = 'HomeCTASeconds';
export const HomeCTASelectCharity = 'HomeCTASelectCharity';
export const HomeCTASelectCharityButton = 'HomeCTASelectCharityButton';
export const HomeCTASelectCharityTitle = 'HomeCTASelectCharityTitle';
export const HomeCTAStandby = 'HomeCTAStandby';
export const HomeCTASwitchCharity = 'HomeCTASwitchCharity';
export const HomeCTATicketNumber = 'HomeCTATicketNumber';
export const HomeCTAViewAllWinners = 'HomeCTAViewAllWinners';
export const HomeCTAWeek = 'HomeCTAWeek';
export const HomeCTAWeeklyPrize = 'HomeCTAWeeklyPrize';
export const HomeCTAWeeklyWinners = 'HomeCTAWeeklyWinners';
export const HomeCTAWeeklyWon = 'HomeCTAWeeklyWon';
export const HomeCTAWinningDetails = 'HomeCTAWinningDetails';
export const HomeCutOffDatePassed = 'HomeCutOffDatePassed';
export const HomeDidYouKnow = 'HomeDidYouKnow';
export const HomeDidYouKnowText1 = 'HomeDidYouKnowText1';
export const HomeDidYouKnowText2 = 'HomeDidYouKnowText2';
export const HomeDidYouKnowText3 = 'HomeDidYouKnowText3';
export const HomeDonateButtonEnabled = 'HomeDonateButtonEnabled';
export const HomeDonateText = 'HomeDonateText';
export const HomeDonateTitle = 'HomeDonateTitle';
export const HomeDrawSoldOut = 'HomeDrawSoldOut';
export const HomeDrawTime = 'HomeDrawTime';
export const HomeHelper5050 = 'HomeHelper5050';
export const HomeHowItWorks = 'HomeHowItWorks';
export const HomeHowItWorksClassicText1 = 'HomeHowItWorksClassicText1';
export const HomeHowItWorksHalfThePot = 'HomeHowItWorksHalfThePot';
export const HomeHowItWorksLearnMore = 'HomeHowItWorksLearnMore';
export const HomeHowItWorksLearnMoreClassic = 'HomeHowItWorksLearnMoreClassic';
export const HomeHowItWorksProgressiveText1 = 'HomeHowItWorksProgressiveText1';
export const HomeHowItWorksText1 = 'HomeHowItWorksText1';
export const HomeHowItWorksText2 = 'HomeHowItWorksText2';
export const HomeJackpot = 'HomeJackpot';
export const HomeJackpotGuaranteeText = 'HomeJackpotGuaranteeText';
export const HomeLastDraw = 'HomeLastDraw';
export const HomeLegacyCTAButton = 'HomeLegacyCTAButton';
export const HomeLegacyTimer = 'HomeLegacyTimer';
export const HomeLegacyTimeUntilNextDraw = 'HomeLegacyTimeUntilNextDraw';
export const HomeLoadingNextDraw = 'HomeLoadingNextDraw';
export const HomeMobileMenu = 'HomeMobileMenu';
export const HomeMyTickets = 'HomeMyTickets';
export const HomeNextDrawBlockBackgroundEnabled = 'HomeNextDrawBlockBackgroundEnabled';
export const HomeNextDrawBlockBackgroundUrl = 'HomeNextDrawBlockBackgroundUrl';
export const HomeNextDrawBlockDrawMessage = 'HomeNextDrawBlockDrawMessage';
export const HomeNextDrawTimerBackgroundEnabled = 'HomeNextDrawTimerBackgroundEnabled';
export const HomeNextDrawTimerBackgroundUrl = 'HomeNextDrawTimerBackgroundUrl';
export const HomeNoDrawsYet = 'HomeNoDrawsYet';
export const HomeNonWinner = 'HomeNonWinner';
export const HomeOperatedBy = 'HomeOperatedBy';
export const HomeParticipatingCaption = 'HomeParticipatingCaption';
export const HomeParticipatingText = 'HomeParticipatingText';
export const HomeRecentWinnersText = 'HomeRecentWinnersText';
export const HomeRecentWinnersTitle = 'HomeRecentWinnersTitle';
export const HomeRightColumnImagePrize = 'HomeRightColumnImagePrize';
export const HomeRightColumnImageType = 'HomeRightColumnImageType';
export const HomeRightColumnImageUrl = 'HomeRightColumnImageUrl';
export const HomeRightColumnImageWinner = 'HomeRightColumnImageWinner';
export const HomeRightColumnThreeLineEnabled = 'HomeRightColumnThreeLineEnabled';
export const HomeSingleDrawCTAButton = 'HomeSingleDrawCTAButton';
export const HomeSingleDrawJackpot = 'HomeSingleDrawJackpot';
export const HomeStandardAbout = 'HomeStandardAbout';
export const HomeStandardCTAButton = 'HomeStandardCTAButton';
export const HomeStandardNextDraw = 'HomeStandardNextDraw';
export const HomeStandardNextDrawPrize = 'HomeStandardNextDrawPrize';
export const HomeStandardNextJackpot = 'HomeStandardNextJackpot';
export const HomeStandardNextJackpotGuaranteed = 'HomeStandardNextJackpotGuaranteed';
export const HomeStandardRecentWinners = 'HomeStandardRecentWinners';
export const HomeStandardShare = 'HomeStandardShare';
export const HomeStandardShareClose = 'HomeStandardShareClose';
export const HomeStandardShareFacebook = 'HomeStandardShareFacebook';
export const HomeStandardShareLinkedIn = 'HomeStandardShareLinkedIn';
export const HomeStandardShareText = 'HomeStandardShareText';
export const HomeStandardShareThanks = 'HomeStandardShareThanks';
export const HomeStandardShareTitle = 'HomeStandardShareTitle';
export const HomeStandardShareTwitter = 'HomeStandardShareTwitter';

// ── Home Standard (additional) ─────────────────────────────────────
export const HomeStandardDrawDatePending = 'HomeStandardDrawDatePending';
export const HomeStandardJackpotFallback = 'HomeStandardJackpotFallback';
export const HomeStandardLoadingText = 'HomeStandardLoadingText';
export const HomeStandardNoActiveDraws = 'HomeStandardNoActiveDraws';
export const HomeStandardWasWinner = 'HomeStandardWasWinner';

// ── Home Style1 ────────────────────────────────────────────────────
export const HomeStyle1LoadingText = 'HomeStyle1LoadingText';
export const HomeStyle1NoActiveDraws = 'HomeStyle1NoActiveDraws';

// ── Home Style2 ────────────────────────────────────────────────────
export const HomeStyle2BonusDrawsDesc = 'HomeStyle2BonusDrawsDesc';
export const HomeStyle2BonusDrawsTitle = 'HomeStyle2BonusDrawsTitle';
export const HomeStyle2CountdownDays = 'HomeStyle2CountdownDays';
export const HomeStyle2CountdownHours = 'HomeStyle2CountdownHours';
export const HomeStyle2CountdownMins = 'HomeStyle2CountdownMins';
export const HomeStyle2CountdownSecs = 'HomeStyle2CountdownSecs';
export const HomeStyle2CTAButton = 'HomeStyle2CTAButton';
export const HomeStyle2DrawCountdown = 'HomeStyle2DrawCountdown';
export const HomeStyle2DrawDate = 'HomeStyle2DrawDate';
export const HomeStyle2Entries = 'HomeStyle2Entries';
export const HomeStyle2JackpotSubtitle = 'HomeStyle2JackpotSubtitle';
export const HomeStyle2NoDraws = 'HomeStyle2NoDraws';
export const HomeStyle2PartnerTier = 'HomeStyle2PartnerTier';
export const HomeStyle2PartnerType = 'HomeStyle2PartnerType';
export const HomeStyle2TicketPrice = 'HomeStyle2TicketPrice';
export const HomeStyle2TicketsSold = 'HomeStyle2TicketsSold';
export const HomeStyle2TopPartners = 'HomeStyle2TopPartners';
export const HomeStyle2UrgencyHigh = 'HomeStyle2UrgencyHigh';
export const HomeStyle2UrgencyLow = 'HomeStyle2UrgencyLow';
export const HomeStyle2UrgencyMedium = 'HomeStyle2UrgencyMedium';

// ── Home Style4 ────────────────────────────────────────────────────
export const HomeStyle4BestValue = 'HomeStyle4BestValue';
export const HomeStyle4Bought = 'HomeStyle4Bought';
export const HomeStyle4Entries = 'HomeStyle4Entries';
export const HomeStyle4JustNow = 'HomeStyle4JustNow';
export const HomeStyle4LoadingText = 'HomeStyle4LoadingText';
export const HomeStyle4Tickets = 'HomeStyle4Tickets';

export const HomeSwitchCharityTitle = 'HomeSwitchCharityTitle';
export const HomeToutText = 'HomeToutText';
export const HomeWasANonWinner = 'HomeWasANonWinner';
export const HomeWasAWinner = 'HomeWasAWinner';
export const HomeWeeklyPot = 'HomeWeeklyPot';
export const HomeWinner = 'HomeWinner';
export const HomeWinners = 'HomeWinners';
export const HomeYoutubeVideoBackgroundImageUrl = 'HomeYoutubeVideoBackgroundImageUrl';
export const HomeYoutubeVideoEnabled = 'HomeYoutubeVideoEnabled';
export const HomeYoutubeVideoId = 'HomeYoutubeVideoId';

// ── HowToPlay ───────────────────────────────────────────────────────
export const HowToPlayAlertAge = 'HowToPlayAlertAge';
export const HowToPlayAlertContact = 'HowToPlayAlertContact';
export const HowToPlayAlertFinal = 'HowToPlayAlertFinal';
export const HowToPlayAlertNotify = 'HowToPlayAlertNotify';
export const HowToPlayAlertResponsible = 'HowToPlayAlertResponsible';
export const HowToPlayAlertTitle = 'HowToPlayAlertTitle';
export const HowToPlayAndRulesTitle = 'HowToPlayAndRulesTitle';
export const HowToPlayChangeSettings = 'HowToPlayChangeSettings';
export const HowToPlayCheckTickets = 'HowToPlayCheckTickets';
export const HowToPlayCTAButton1 = 'HowToPlayCTAButton1';
export const HowToPlayCTAButton2 = 'HowToPlayCTAButton2';
export const HowToPlayCTAGetStarted = 'HowToPlayCTAGetStarted';
export const HowToPlayCTAQuickTitle = 'HowToPlayCTAQuickTitle';
export const HowToPlayCTASubtitle = 'HowToPlayCTASubtitle';
export const HowToPlayCTATitle = 'HowToPlayCTATitle';
export const HowToPlayDetailedTitle = 'HowToPlayDetailedTitle';
export const HowToPlayHeroSubtitle = 'HowToPlayHeroSubtitle';
export const HowToPlayHeroTagline = 'HowToPlayHeroTagline';
export const HowToPlayNavText = 'HowToPlayNavText';
export const HowToPlayOrderHistory = 'HowToPlayOrderHistory';
export const HowToPlayPurchaseTickets = 'HowToPlayPurchaseTickets';
export const HowToPlayRegister = 'HowToPlayRegister';
export const HowToPlaySectionRegisterStep1 = 'HowToPlaySectionRegisterStep1';
export const HowToPlaySectionRegisterStep2 = 'HowToPlaySectionRegisterStep2';
export const HowToPlaySectionRegisterStep3 = 'HowToPlaySectionRegisterStep3';
export const HowToPlaySectionRegisterStep4 = 'HowToPlaySectionRegisterStep4';
export const HowToPlaySectionRegisterStep5 = 'HowToPlaySectionRegisterStep5';
export const HowToPlaySectionRegisterStep6 = 'HowToPlaySectionRegisterStep6';
export const HowToPlaySectionRegisterTitle = 'HowToPlaySectionRegisterTitle';
export const HowToPlaySectionSettingsStep1 = 'HowToPlaySectionSettingsStep1';
export const HowToPlaySectionSettingsStep2 = 'HowToPlaySectionSettingsStep2';
export const HowToPlaySectionSettingsStep3 = 'HowToPlaySectionSettingsStep3';
export const HowToPlaySectionSettingsStep4 = 'HowToPlaySectionSettingsStep4';
export const HowToPlaySectionSettingsStep5 = 'HowToPlaySectionSettingsStep5';
export const HowToPlaySectionSettingsTitle = 'HowToPlaySectionSettingsTitle';
export const HowToPlayStep1Desc = 'HowToPlayStep1Desc';
export const HowToPlayStep1Tip1 = 'HowToPlayStep1Tip1';
export const HowToPlayStep1Tip2 = 'HowToPlayStep1Tip2';
export const HowToPlayStep1Tip3 = 'HowToPlayStep1Tip3';
export const HowToPlayStep1Title = 'HowToPlayStep1Title';
export const HowToPlayStep2Desc = 'HowToPlayStep2Desc';
export const HowToPlayStep2Tip1 = 'HowToPlayStep2Tip1';
export const HowToPlayStep2Tip2 = 'HowToPlayStep2Tip2';
export const HowToPlayStep2Tip3 = 'HowToPlayStep2Tip3';
export const HowToPlayStep2Title = 'HowToPlayStep2Title';
export const HowToPlayStep3Desc = 'HowToPlayStep3Desc';
export const HowToPlayStep3Tip1 = 'HowToPlayStep3Tip1';
export const HowToPlayStep3Tip2 = 'HowToPlayStep3Tip2';
export const HowToPlayStep3Tip3 = 'HowToPlayStep3Tip3';
export const HowToPlayStep3Title = 'HowToPlayStep3Title';
export const HowToPlayStep4Desc = 'HowToPlayStep4Desc';
export const HowToPlayStep4Tip1 = 'HowToPlayStep4Tip1';
export const HowToPlayStep4Tip2 = 'HowToPlayStep4Tip2';
export const HowToPlayStep4Tip3 = 'HowToPlayStep4Tip3';
export const HowToPlayStep4Title = 'HowToPlayStep4Title';
export const HowToPlayText = 'HowToPlayText';
export const HowToPlayTextClassic = 'HowToPlayTextClassic';
export const HowToPlayTextCTA = 'HowToPlayTextCTA';
export const HowToPlayTitle = 'HowToPlayTitle';

// ── Matt ───────────────────────────────────────────────────────
export const Matt = 'Matt';

// ── Modal ───────────────────────────────────────────────────────
export const ModalAccountDeactivatedText1 = 'ModalAccountDeactivatedText1';
export const ModalAccountDeactivatedText2 = 'ModalAccountDeactivatedText2';
export const ModalAccountDeactivatedTitle = 'ModalAccountDeactivatedTitle';
export const ModalAccountExistsText = 'ModalAccountExistsText';
export const ModalAccountExistsTitle = 'ModalAccountExistsTitle';
export const ModalAccountLockContactUs = 'ModalAccountLockContactUs';
export const ModalAccountLockText = 'ModalAccountLockText';
export const ModalAccountLockTitle = 'ModalAccountLockTitle';
export const ModalAgeGateConfirm = 'ModalAgeGateConfirm';
export const ModalAgeGateLetsGo = 'ModalAgeGateLetsGo';
export const ModalAgeGateText = 'ModalAgeGateText';
export const ModalAgeGateTitle = 'ModalAgeGateTitle';
export const ModalBackToLogin = 'ModalBackToLogin';
export const ModalBonusTicketsButton = 'ModalBonusTicketsButton';
export const ModalBonusTicketsText = 'ModalBonusTicketsText';
export const ModalBonusTicketsTitle = 'ModalBonusTicketsTitle';
export const ModalClose = 'ModalClose';
export const ModalComingSoonText = 'ModalComingSoonText';
export const ModalComingSoonTitle = 'ModalComingSoonTitle';
export const ModalCompleteGetStarted = 'ModalCompleteGetStarted';
export const ModalCompleteMessage = 'ModalCompleteMessage';
export const ModalCompleteMessageBefore = 'ModalCompleteMessageBefore';
export const ModalCompleteNotReceived = 'ModalCompleteNotReceived';
export const ModalCompleteSendAgain = 'ModalCompleteSendAgain';
export const ModalCompleteTitle = 'ModalCompleteTitle';
export const ModalConfirmEmailSuccessLetsGo = 'ModalConfirmEmailSuccessLetsGo';
export const ModalConfirmEmailSuccessText = 'ModalConfirmEmailSuccessText';
export const ModalConfirmEmailSuccessTitle = 'ModalConfirmEmailSuccessTitle';
export const ModalFacebookEmailRequiredText = 'ModalFacebookEmailRequiredText';
export const ModalFacebookEmailRequiredTitle = 'ModalFacebookEmailRequiredTitle';
export const ModalFacebookLoginErrorText = 'ModalFacebookLoginErrorText';
export const ModalFacebookLoginErrorTitle = 'ModalFacebookLoginErrorTitle';
export const ModalFacebookNotFoundText = 'ModalFacebookNotFoundText';
export const ModalFacebookNotFoundTitle = 'ModalFacebookNotFoundTitle';
export const ModalFacebookRedirectCreateAccount = 'ModalFacebookRedirectCreateAccount';
export const ModalFacebookRedirectLogIn = 'ModalFacebookRedirectLogIn';
export const ModalFacebookRedirectText = 'ModalFacebookRedirectText';
export const ModalFacebookRedirectTitle = 'ModalFacebookRedirectTitle';
export const ModalForgotPasswordEmail = 'ModalForgotPasswordEmail';
export const ModalForgotPasswordEmailError = 'ModalForgotPasswordEmailError';
export const ModalForgotPasswordReset = 'ModalForgotPasswordReset';
export const ModalForgotPasswordReturn = 'ModalForgotPasswordReturn';
export const ModalForgotPasswordText = 'ModalForgotPasswordText';
export const ModalForgotPasswordTitle = 'ModalForgotPasswordTitle';
export const ModalGoogleLoginErrorText = 'ModalGoogleLoginErrorText';
export const ModalGoogleLoginErrorTitle = 'ModalGoogleLoginErrorTitle';
export const ModalGoogleNotFoundText = 'ModalGoogleNotFoundText';
export const ModalGoogleNotFoundTitle = 'ModalGoogleNotFoundTitle';
export const ModalGoogleRedirectCreateAccount = 'ModalGoogleRedirectCreateAccount';
export const ModalGoogleRedirectLogIn = 'ModalGoogleRedirectLogIn';
export const ModalGoogleRedirectText = 'ModalGoogleRedirectText';
export const ModalGoogleRedirectTitle = 'ModalGoogleRedirectTitle';
export const ModalInviteCompleteText = 'ModalInviteCompleteText';
export const ModalInviteCompleteTitle = 'ModalInviteCompleteTitle';
export const ModalInviteCTAButton = 'ModalInviteCTAButton';
export const ModalInviteSuccessLetsGo = 'ModalInviteSuccessLetsGo';
export const ModalInviteText = 'ModalInviteText';
export const ModalInviteTitle = 'ModalInviteTitle';
export const ModalLoginEmail = 'ModalLoginEmail';
export const ModalLoginFacebook = 'ModalLoginFacebook';
export const ModalLoginFormEmail = 'ModalLoginFormEmail';
export const ModalLoginFormEmailRequired = 'ModalLoginFormEmailRequired';
export const ModalLoginFormLoginNow = 'ModalLoginFormLoginNow';
export const ModalLoginFormPassword = 'ModalLoginFormPassword';
export const ModalLoginFormPasswordForgot = 'ModalLoginFormPasswordForgot';
export const ModalLoginFormPasswordRequest = 'ModalLoginFormPasswordRequest';
export const ModalLoginFormPasswordRequired = 'ModalLoginFormPasswordRequired';
export const ModalLoginFormText = 'ModalLoginFormText';
export const ModalLoginFormTitle = 'ModalLoginFormTitle';
export const ModalLoginGoogle = 'ModalLoginGoogle';
export const ModalLoginRequiredEmail = 'ModalLoginRequiredEmail';
export const ModalLoginRequiredFacebook = 'ModalLoginRequiredFacebook';
export const ModalLoginRequiredGoogle = 'ModalLoginRequiredGoogle';
export const ModalLoginRequiredText = 'ModalLoginRequiredText';
export const ModalLoginRequiredTitle = 'ModalLoginRequiredTitle';
export const ModalLoginText = 'ModalLoginText';
export const ModalLoginTitle = 'ModalLoginTitle';
export const ModalMaintenaceText = 'ModalMaintenaceText';
export const ModalMaintenaceTitle = 'ModalMaintenaceTitle';
export const ModalMaintenanceAwesome = 'ModalMaintenanceAwesome';
export const ModalMaintenanceText = 'ModalMaintenanceText';
export const ModalMaintenanceTitle = 'ModalMaintenanceTitle';
export const ModalMemberExistsText = 'ModalMemberExistsText';
export const ModalMemberExistsTitle = 'ModalMemberExistsTitle';
export const ModalNoAccountText = 'ModalNoAccountText';
export const ModalNoAccountTitle = 'ModalNoAccountTitle';
export const ModalOr = 'ModalOr';
export const ModalPasswordResetConfirm = 'ModalPasswordResetConfirm';
export const ModalPasswordResetConfirmationText = 'ModalPasswordResetConfirmationText';
export const ModalPasswordResetConfirmationTitle = 'ModalPasswordResetConfirmationTitle';
export const ModalPasswordResetConfirmPassword = 'ModalPasswordResetConfirmPassword';
export const ModalPasswordResetCTAButton = 'ModalPasswordResetCTAButton';
export const ModalPasswordResetEnter = 'ModalPasswordResetEnter';
export const ModalPasswordResetError = 'ModalPasswordResetError';
export const ModalPasswordResetFormConfirmPassword = 'ModalPasswordResetFormConfirmPassword';
export const ModalPasswordResetFormConfirmReset = 'ModalPasswordResetFormConfirmReset';
export const ModalPasswordResetFormError = 'ModalPasswordResetFormError';
export const ModalPasswordResetFormMatchError = 'ModalPasswordResetFormMatchError';
export const ModalPasswordResetFormNewPassword = 'ModalPasswordResetFormNewPassword';
export const ModalPasswordResetFormText = 'ModalPasswordResetFormText';
export const ModalPasswordResetFormTitle = 'ModalPasswordResetFormTitle';
export const ModalPasswordResetLogin = 'ModalPasswordResetLogin';
export const ModalPasswordResetSpamWarning = 'ModalPasswordResetSpamWarning';
export const ModalPasswordResetSuccessfulText = 'ModalPasswordResetSuccessfulText';
export const ModalPasswordResetSuccessfulTitle = 'ModalPasswordResetSuccessfulTitle';
export const ModalPasswordResetSuccessLetsGo = 'ModalPasswordResetSuccessLetsGo';
export const ModalPasswordResetSuccessText = 'ModalPasswordResetSuccessText';
export const ModalPasswordResetSuccessTitle = 'ModalPasswordResetSuccessTitle';
export const ModalPasswordResetText = 'ModalPasswordResetText';
export const ModalPasswordResetTitle = 'ModalPasswordResetTitle';
export const ModalPostalCodeFacebook = 'ModalPostalCodeFacebook';
export const ModalPostalCodePostalCode = 'ModalPostalCodePostalCode';
export const ModalPostalCodePostalCodeError = 'ModalPostalCodePostalCodeError';
export const ModalPostalCodeText = 'ModalPostalCodeText';
export const ModalPostalCodeTitle = 'ModalPostalCodeTitle';
export const ModalReCaptchaError = 'ModalReCaptchaError';
export const ModalResendEmailEndText = 'ModalResendEmailEndText';
export const ModalResendEmailEndTitle = 'ModalResendEmailEndTitle';
export const ModalResendEmailStartText = 'ModalResendEmailStartText';
export const ModalResendEmailStartTitle = 'ModalResendEmailStartTitle';
export const ModalResetPasswordResent = 'ModalResetPasswordResent';
export const ModalResetPasswordSendAgain = 'ModalResetPasswordSendAgain';
export const ModalResetPasswordText = 'ModalResetPasswordText';
export const ModalResetPasswordTitle = 'ModalResetPasswordTitle';
export const ModalSandboxQuestions = 'ModalSandboxQuestions';
export const ModalSandboxSeeLess = 'ModalSandboxSeeLess';
export const ModalSandboxSeeMore = 'ModalSandboxSeeMore';
export const ModalSandboxText = 'ModalSandboxText';
export const ModalSandboxTitle = 'ModalSandboxTitle';
export const ModalSetInitialEmailAfter = 'ModalSetInitialEmailAfter';
export const ModalSetInitialEmailButton = 'ModalSetInitialEmailButton';
export const ModalSetInitialEmailButtonPrompt = 'ModalSetInitialEmailButtonPrompt';
export const ModalSetInitialEmailText = 'ModalSetInitialEmailText';
export const ModalSetInitialEmailTitle = 'ModalSetInitialEmailTitle';
export const ModalSignUpEmail = 'ModalSignUpEmail';
export const ModalSignUpFacebook = 'ModalSignUpFacebook';
export const ModalSignUpFormButton = 'ModalSignUpFormButton';
export const ModalSignUpFormConfirmEmail = 'ModalSignUpFormConfirmEmail';
export const ModalSignUpFormConfirmPassword = 'ModalSignUpFormConfirmPassword';
export const ModalSignUpFormEmail = 'ModalSignUpFormEmail';
export const ModalSignUpFormEmailCollision = 'ModalSignUpFormEmailCollision';
export const ModalSignUpFormEmailMatchError = 'ModalSignUpFormEmailMatchError';
export const ModalSignUpFormFacebook = 'ModalSignUpFormFacebook';
export const ModalSignUpFormFirstName = 'ModalSignUpFormFirstName';
export const ModalSignUpFormFirstNameRequired = 'ModalSignUpFormFirstNameRequired';
export const ModalSignUpFormGoogle = 'ModalSignUpFormGoogle';
export const ModalSignUpFormLastName = 'ModalSignUpFormLastName';
export const ModalSignUpFormLastNameRequired = 'ModalSignUpFormLastNameRequired';
export const ModalSignUpFormPassword = 'ModalSignUpFormPassword';
export const ModalSignUpFormPasswordMatchError = 'ModalSignUpFormPasswordMatchError';
export const ModalSignUpFormPasswordScoreWeak = 'ModalSignUpFormPasswordScoreWeak';
export const ModalSignUpFormPasswordScoreWord0 = 'ModalSignUpFormPasswordScoreWord0';
export const ModalSignUpFormPasswordScoreWord1 = 'ModalSignUpFormPasswordScoreWord1';
export const ModalSignUpFormPasswordScoreWord2 = 'ModalSignUpFormPasswordScoreWord2';
export const ModalSignUpFormPasswordScoreWord3 = 'ModalSignUpFormPasswordScoreWord3';
export const ModalSignUpFormPasswordScoreWord4 = 'ModalSignUpFormPasswordScoreWord4';
export const ModalSignUpFormPasswordsMatchError = 'ModalSignUpFormPasswordsMatchError';
export const ModalSignUpFormPostalCode = 'ModalSignUpFormPostalCode';
export const ModalSignUpFormPostalCodeError = 'ModalSignUpFormPostalCodeError';
export const ModalSignUpFormPrivacyBefore = 'ModalSignUpFormPrivacyBefore';
export const ModalSignUpFormPrivacyButton = 'ModalSignUpFormPrivacyButton';
export const ModalSignUpFormTermsBefore = 'ModalSignUpFormTermsBefore';
export const ModalSignUpFormTermsButton = 'ModalSignUpFormTermsButton';
export const ModalSignUpFormText = 'ModalSignUpFormText';
export const ModalSignUpFormTitle = 'ModalSignUpFormTitle';
export const ModalSignUpFormValidEmailError = 'ModalSignUpFormValidEmailError';
export const ModalSignUpGoogle = 'ModalSignUpGoogle';
export const ModalSignUpText = 'ModalSignUpText';
export const ModalSignUpTitle = 'ModalSignUpTitle';
export const ModalSignUpWorking = 'ModalSignUpWorking';
export const ModalUnsubscribeErrorText = 'ModalUnsubscribeErrorText';
export const ModalUnsubscribeErrorTitle = 'ModalUnsubscribeErrorTitle';
export const ModalUnsubscribeText = 'ModalUnsubscribeText';
export const ModalUnsubscribeTitle = 'ModalUnsubscribeTitle';

// ── MyTickets ───────────────────────────────────────────────────────
export const MyTicketsBuyFromExisting = 'MyTicketsBuyFromExisting';
export const MyTicketsBuyMore = 'MyTicketsBuyMore';
export const MyTicketsBuyNew = 'MyTicketsBuyNew';
export const MyTicketsBuyNow = 'MyTicketsBuyNow';
export const MyTicketsCollapse = 'MyTicketsCollapse';
export const MyTicketsDrawDate = 'MyTicketsDrawDate';
export const MyTicketsDraws = 'MyTicketsDraws';
export const MyTicketsEntries = 'MyTicketsEntries';
export const MyTicketsEnvelopeNo = 'MyTicketsEnvelopeNo';
export const MyTicketsExpand = 'MyTicketsExpand';
export const MyTicketsInDraw = 'MyTicketsInDraw';
export const MyTicketsInstructions = 'MyTicketsInstructions';
export const MyTicketsMultiple = 'MyTicketsMultiple';
export const MyTicketsMyTickets = 'MyTicketsMyTickets';
export const MyTicketsNoTickets = 'MyTicketsNoTickets';
export const MyTicketsOr = 'MyTicketsOr';
export const MyTicketsOrSeparator = 'MyTicketsOrSeparator';
export const MyTicketsPricePerTicket = 'MyTicketsPricePerTicket';
export const MyTicketsRenew = 'MyTicketsRenew';
export const MyTicketsSelectDuration = 'MyTicketsSelectDuration';
export const MyTicketsSingle = 'MyTicketsSingle';
export const MyTicketsTicketNo = 'MyTicketsTicketNo';
export const MyTicketsTickets = 'MyTicketsTickets';
export const MyTicketsValidFor = 'MyTicketsValidFor';

// ── OrderHistory ───────────────────────────────────────────────────────
export const OrderHistoryDate = 'OrderHistoryDate';
export const OrderHistoryDrawDate = 'OrderHistoryDrawDate';
export const OrderHistoryEach = 'OrderHistoryEach';
export const OrderHistoryEnvelope = 'OrderHistoryEnvelope';
export const OrderHistoryInvoiceNumber = 'OrderHistoryInvoiceNumber';
export const OrderHistoryMethod = 'OrderHistoryMethod';
export const OrderHistoryMobileTextPurchase = 'OrderHistoryMobileTextPurchase';
export const OrderHistoryMobileTextYour = 'OrderHistoryMobileTextYour';
export const OrderHistoryNumbers = 'OrderHistoryNumbers';
export const OrderHistoryOrderHistory = 'OrderHistoryOrderHistory';
export const OrderHistoryPrint = 'OrderHistoryPrint';
export const OrderHistoryRefunded = 'OrderHistoryRefunded';
export const OrderHistoryTickets = 'OrderHistoryTickets';
export const OrderHistoryTotal = 'OrderHistoryTotal';
export const OrderHistoryTransactionHeader = 'OrderHistoryTransactionHeader';

// ── PrivacyPolicy ───────────────────────────────────────────────────────
export const PrivacyPolicyText = 'PrivacyPolicyText';
export const PrivacyPolicyTitle = 'PrivacyPolicyTitle';

// ── Progressive5050 ────────────────────────────────────────────────
export const ProgStyle2_Loading = 'ProgStyle2_Loading';
export const ProgStyle3_Loading = 'ProgStyle3_Loading';

// ── Purchase ───────────────────────────────────────────────────────
export const PurchaseAmountPerPurchaseError1 = 'PurchaseAmountPerPurchaseError1';
export const PurchaseAmountPerPurchaseError2 = 'PurchaseAmountPerPurchaseError2';
export const PurchaseBonusTickets = 'PurchaseBonusTickets';
export const PurchaseBonusTicketsMessage = 'PurchaseBonusTicketsMessage';
export const PurchaseClearSelections = 'PurchaseClearSelections';
export const PurchaseCTAAfter = 'PurchaseCTAAfter';
export const PurchaseCTABefore = 'PurchaseCTABefore';
export const PurchaseCTACard = 'PurchaseCTACard';
export const PurchaseCTACheckout = 'PurchaseCTACheckout';
export const PurchaseCTACheckoutNumber = 'PurchaseCTACheckoutNumber';
export const PurchaseCTACheckoutPayment = 'PurchaseCTACheckoutPayment';
export const PurchaseCTASelectCardNumber = 'PurchaseCTASelectCardNumber';
export const PurchaseCTASelectCardText = 'PurchaseCTASelectCardText';
export const PurchaseCTASelectTicketsNumber = 'PurchaseCTASelectTicketsNumber';
export const PurchaseCTASelectTicketsText = 'PurchaseCTASelectTicketsText';
export const PurchaseCTATickets = 'PurchaseCTATickets';
export const PurchaseCustomFieldsError = 'PurchaseCustomFieldsError';
export const PurchaseDrawPlural = 'PurchaseDrawPlural';
export const PurchaseDraws = 'PurchaseDraws';
export const PurchaseDrawSingular = 'PurchaseDrawSingular';
export const PurchaseDrawSoldOutText = 'PurchaseDrawSoldOutText';
export const PurchaseEach = 'PurchaseEach';
export const PurchaseExistingTicketsHi = 'PurchaseExistingTicketsHi';
export const PurchaseExistingTicketsMessage = 'PurchaseExistingTicketsMessage';
export const PurchaseExistingTicketsTitle = 'PurchaseExistingTicketsTitle';
export const PurchaseGenericError = 'PurchaseGenericError';
export const PurchaseJackpotAmountWonError1 = 'PurchaseJackpotAmountWonError1';
export const PurchaseJackpotAmountWonError2 = 'PurchaseJackpotAmountWonError2';
export const PurchaseMinimumText1 = 'PurchaseMinimumText1';
export const PurchaseMinimumText2 = 'PurchaseMinimumText2';
export const PurchaseNewTicketWarning = 'PurchaseNewTicketWarning';
export const PurchaseNext = 'PurchaseNext';
export const PurchaseNext12Draws = 'PurchaseNext12Draws';
export const PurchaseNext24Draws = 'PurchaseNext24Draws';
export const PurchaseNext4Draws = 'PurchaseNext4Draws';
export const PurchaseNext52Draws = 'PurchaseNext52Draws';
export const PurchaseNextDraw = 'PurchaseNextDraw';
export const PurchaseNumberOfDraws = 'PurchaseNumberOfDraws';
export const PurchasePrompt = 'PurchasePrompt';
export const PurchaseSelectCardEnvelopeSelected = 'PurchaseSelectCardEnvelopeSelected';
export const PurchaseSelectCardHeader = 'PurchaseSelectCardHeader';
export const PurchaseSelectCardMyCard = 'PurchaseSelectCardMyCard';
export const PurchaseText = 'PurchaseText';
export const PurchaseTicketPlural = 'PurchaseTicketPlural';
export const PurchaseTickets = 'PurchaseTickets';
export const PurchaseTicketSingular = 'PurchaseTicketSingular';
export const PurchaseTicketsPerPurchaseError1 = 'PurchaseTicketsPerPurchaseError1';
export const PurchaseTicketsPerPurchaseError2 = 'PurchaseTicketsPerPurchaseError2';
export const PurchaseTicketsSoldError1 = 'PurchaseTicketsSoldError1';
export const PurchaseTicketsSoldError2 = 'PurchaseTicketsSoldError2';
export const PurchaseTitle = 'PurchaseTitle';
export const PurchaseTitleClassic = 'PurchaseTitleClassic';
export const PurchaseTitleError = 'PurchaseTitleError';
export const PurchaseTitleSoldOutTitle = 'PurchaseTitleSoldOutTitle';
export const PurchaseTooManyTicketsError1 = 'PurchaseTooManyTicketsError1';
export const PurchaseTooManyTicketsError2 = 'PurchaseTooManyTicketsError2';
export const PurchaseTotal = 'PurchaseTotal';

// ── PurchaseComplete ───────────────────────────────────────────────────────
export const PurchaseCompleteBuyAgain = 'PurchaseCompleteBuyAgain';
export const PurchaseCompleteFailedText1 = 'PurchaseCompleteFailedText1';
export const PurchaseCompleteFailedText2 = 'PurchaseCompleteFailedText2';
export const PurchaseCompleteFailedTitle = 'PurchaseCompleteFailedTitle';
export const PurchaseCompleteGeneralError1 = 'PurchaseCompleteGeneralError1';
export const PurchaseCompleteGeneralError2 = 'PurchaseCompleteGeneralError2';
export const PurchaseCompleteGenerating = 'PurchaseCompleteGenerating';
export const PurchaseCompleteHome = 'PurchaseCompleteHome';
export const PurchaseCompleteProcessing = 'PurchaseCompleteProcessing';
export const PurchaseCompleteReceipt = 'PurchaseCompleteReceipt';
export const PurchaseCompleteSuccesstext = 'PurchaseCompleteSuccesstext';
export const PurchaseCompleteSuccessTitle = 'PurchaseCompleteSuccessTitle';

// ── ResponsibleGaming ───────────────────────────────────────────────────────
// Legacy plain-string keys (kept for backward compat with dashboard content editors)
export const ResponsbileGamingText = 'ResponsbileGamingText';
export const ResponsbileGamingTitle = 'ResponsbileGamingTitle';

// Sub-key enum — each value is the SectionName stored in OrganizationText
export const ResponsibleGamingTitle = {
  PAGE_TITLE:               'ResponsibleGaming_PAGE_TITLE',
  INTRO_TEXT:               'ResponsibleGaming_INTRO_TEXT',
  PLAY_RESPONSIBLY_HEADING: 'ResponsibleGaming_PLAY_RESPONSIBLY_HEADING',
  GUIDELINES_INTRO:         'ResponsibleGaming_GUIDELINES_INTRO',
  GUIDELINE_1:              'ResponsibleGaming_GUIDELINE_1',
  GUIDELINE_2:              'ResponsibleGaming_GUIDELINE_2',
  GUIDELINE_3:              'ResponsibleGaming_GUIDELINE_3',
  GUIDELINE_4:              'ResponsibleGaming_GUIDELINE_4',
  GUIDELINE_5:              'ResponsibleGaming_GUIDELINE_5',
  GUIDELINE_6:              'ResponsibleGaming_GUIDELINE_6',
  WARNING_SIGNS_HEADING:    'ResponsibleGaming_WARNING_SIGNS_HEADING',
  WARNING_SIGNS_INTRO:      'ResponsibleGaming_WARNING_SIGNS_INTRO',
  WARNING_1:                'ResponsibleGaming_WARNING_1',
  WARNING_2:                'ResponsibleGaming_WARNING_2',
  WARNING_3:                'ResponsibleGaming_WARNING_3',
  WARNING_4:                'ResponsibleGaming_WARNING_4',
  WARNING_5:                'ResponsibleGaming_WARNING_5',
  WARNING_6:                'ResponsibleGaming_WARNING_6',
  GET_HELP_HEADING:         'ResponsibleGaming_GET_HELP_HEADING',
  GET_HELP_INTRO:           'ResponsibleGaming_GET_HELP_INTRO',
  HELPLINE_TITLE:           'ResponsibleGaming_HELPLINE_TITLE',
  HELPLINE_PHONE:           'ResponsibleGaming_HELPLINE_PHONE',
  HELPLINE_DESC:            'ResponsibleGaming_HELPLINE_DESC',
  GA_TITLE:                 'ResponsibleGaming_GA_TITLE',
  GA_URL:                   'ResponsibleGaming_GA_URL',
  GA_DESC:                  'ResponsibleGaming_GA_DESC',
  NCPG_TITLE:               'ResponsibleGaming_NCPG_TITLE',
  NCPG_URL:                  'ResponsibleGaming_NCPG_URL',
  NCPG_DESC:                 'ResponsibleGaming_NCPG_DESC',
  SELF_EXCLUSION_HEADING:   'ResponsibleGaming_SELF_EXCLUSION_HEADING',
  SELF_EXCLUSION_INTRO:     'ResponsibleGaming_SELF_EXCLUSION_INTRO',
  SELF_EXCLUSION_1:         'ResponsibleGaming_SELF_EXCLUSION_1',
  SELF_EXCLUSION_2:         'ResponsibleGaming_SELF_EXCLUSION_2',
  SELF_EXCLUSION_3:         'ResponsibleGaming_SELF_EXCLUSION_3',
  SELF_EXCLUSION_CONTACT:   'ResponsibleGaming_SELF_EXCLUSION_CONTACT',
  UNDERAGE_HEADING:         'ResponsibleGaming_UNDERAGE_HEADING',
  UNDERAGE_TEXT:             'ResponsibleGaming_UNDERAGE_TEXT',
  COMMITMENT_HEADING:       'ResponsibleGaming_COMMITMENT_HEADING',
  COMMITMENT_TEXT:           'ResponsibleGaming_COMMITMENT_TEXT',
};

// Mapping: sub-key enum value → SectionName (identity mapping for use with c())
export const ResponsibleGamingText = Object.fromEntries(
  Object.entries(ResponsibleGamingTitle).map(([k, v]) => [v, v])
);

// Fallback default text (English) — used when DB has no content yet
export const ResponsibleGamingDefaultText = {
  [ResponsibleGamingTitle.PAGE_TITLE]:               'Responsible Gaming',
  [ResponsibleGamingTitle.INTRO_TEXT]:               'Gaming should be fun, entertaining, and enjoyed responsibly. We are committed to providing a safe and supportive environment for all participants. Please take a moment to review the information below.',
  [ResponsibleGamingTitle.PLAY_RESPONSIBLY_HEADING]: 'Play Responsibly',
  [ResponsibleGamingTitle.GUIDELINES_INTRO]:         'Follow these guidelines to keep gaming enjoyable:',
  [ResponsibleGamingTitle.GUIDELINE_1]:              'Set a budget before you play and stick to it',
  [ResponsibleGamingTitle.GUIDELINE_2]:              'Only play with money you can afford to lose',
  [ResponsibleGamingTitle.GUIDELINE_3]:              'Never chase losses or borrow money to play',
  [ResponsibleGamingTitle.GUIDELINE_4]:              'Take regular breaks and set time limits',
  [ResponsibleGamingTitle.GUIDELINE_5]:              'Don\'t play when upset, stressed, or under the influence',
  [ResponsibleGamingTitle.GUIDELINE_6]:              'Balance gaming with other recreational activities',
  [ResponsibleGamingTitle.WARNING_SIGNS_HEADING]:    'Warning Signs',
  [ResponsibleGamingTitle.WARNING_SIGNS_INTRO]:      'If you recognize any of these signs in yourself or someone you know, it may be time to seek help:',
  [ResponsibleGamingTitle.WARNING_1]:                'Spending more money or time on gaming than intended',
  [ResponsibleGamingTitle.WARNING_2]:                'Borrowing money or selling possessions to fund gaming',
  [ResponsibleGamingTitle.WARNING_3]:                'Neglecting responsibilities, work, or relationships',
  [ResponsibleGamingTitle.WARNING_4]:                'Feeling anxious, irritable, or restless when not playing',
  [ResponsibleGamingTitle.WARNING_5]:                'Lying to family or friends about gaming habits',
  [ResponsibleGamingTitle.WARNING_6]:                'Using gaming as an escape from problems or negative feelings',
  [ResponsibleGamingTitle.GET_HELP_HEADING]:         'Get Help',
  [ResponsibleGamingTitle.GET_HELP_INTRO]:           'If you or someone you know needs help with problem gambling, these resources are available 24/7:',
  [ResponsibleGamingTitle.HELPLINE_TITLE]:           'National Problem Gambling Helpline',
  [ResponsibleGamingTitle.HELPLINE_PHONE]:           '1-800-522-4700',
  [ResponsibleGamingTitle.HELPLINE_DESC]:            'Free, confidential, 24/7 helpline for problem gamblers and their families.',
  [ResponsibleGamingTitle.GA_TITLE]:                 'Gamblers Anonymous',
  [ResponsibleGamingTitle.GA_URL]:                   'www.gamblersanonymous.org',
  [ResponsibleGamingTitle.GA_DESC]:                  'A fellowship of people who share their experience, strength, and hope to recover from gambling addiction.',
  [ResponsibleGamingTitle.NCPG_TITLE]:               'National Council on Problem Gambling',
  [ResponsibleGamingTitle.NCPG_URL]:                 'www.ncpgambling.org',
  [ResponsibleGamingTitle.NCPG_DESC]:                'Resources, research, and programs for responsible gambling advocacy.',
  [ResponsibleGamingTitle.SELF_EXCLUSION_HEADING]:   'Self-Exclusion',
  [ResponsibleGamingTitle.SELF_EXCLUSION_INTRO]:     'If you feel you need a break from gaming, our self-exclusion program allows you to voluntarily restrict your access to the platform. Options include:',
  [ResponsibleGamingTitle.SELF_EXCLUSION_1]:         'Temporary self-exclusion (30 days, 60 days, or 90 days)',
  [ResponsibleGamingTitle.SELF_EXCLUSION_2]:         'Extended self-exclusion (6 months or 1 year)',
  [ResponsibleGamingTitle.SELF_EXCLUSION_3]:         'Permanent self-exclusion',
  [ResponsibleGamingTitle.SELF_EXCLUSION_CONTACT]:   'To request self-exclusion, please contact the organization operating your draw or reach out to our support team through the Contact page.',
  [ResponsibleGamingTitle.UNDERAGE_HEADING]:         'Underage Gaming Prevention',
  [ResponsibleGamingTitle.UNDERAGE_TEXT]:             'Participation in lottery and fundraising draws is restricted to individuals of legal age in their jurisdiction. We employ age verification measures and will close any account found to be operated by a minor.',
  [ResponsibleGamingTitle.COMMITMENT_HEADING]:       'Our Commitment',
  [ResponsibleGamingTitle.COMMITMENT_TEXT]:           'We are dedicated to maintaining the highest standards of responsible gaming. Our platform is designed to support charitable organizations while ensuring a safe and enjoyable experience for all participants.',
};

// ── SelectCard ───────────────────────────────────────────────────────
export const SelectCardClearCart = 'SelectCardClearCart';
export const SelectCardDrawDate = 'SelectCardDrawDate';
export const SelectCardPrice = 'SelectCardPrice';

// ── Settings ───────────────────────────────────────────────────────
export const SettingsAnonymousWinnerHeader = 'SettingsAnonymousWinnerHeader';
export const SettingsAnonymousWinnerMessage = 'SettingsAnonymousWinnerMessage';
export const SettingsBillingTitle = 'SettingsBillingTitle';
export const SettingsButtonMessageFailed = 'SettingsButtonMessageFailed';
export const SettingsButtonMessageNeutral = 'SettingsButtonMessageNeutral';
export const SettingsButtonMessageSaved = 'SettingsButtonMessageSaved';
export const SettingsButtonMessageUpdating = 'SettingsButtonMessageUpdating';
export const SettingsCellular = 'SettingsCellular';
export const SettingsDate = 'SettingsDate';
export const SettingsJackpot = 'SettingsJackpot';
export const SettingsJackpotCTA = 'SettingsJackpotCTA';
export const SettingsJackpotWinner = 'SettingsJackpotWinner';
export const SettingsNonWinner = 'SettingsNonWinner';
export const SettingsPasswordButtonMessageFailed = 'SettingsPasswordButtonMessageFailed';
export const SettingsPasswordButtonMessageNeutral = 'SettingsPasswordButtonMessageNeutral';
export const SettingsPasswordButtonMessageSaved = 'SettingsPasswordButtonMessageSaved';
export const SettingsPasswordButtonMessageUpdating = 'SettingsPasswordButtonMessageUpdating';
export const SettingsPasswordConfirmPassword = 'SettingsPasswordConfirmPassword';
export const SettingsPasswordConfirmPasswordError = 'SettingsPasswordConfirmPasswordError';
export const SettingsPasswordCurrentPassword = 'SettingsPasswordCurrentPassword';
export const SettingsPasswordCurrentPasswordError = 'SettingsPasswordCurrentPasswordError';
export const SettingsPasswordHeader = 'SettingsPasswordHeader';
export const SettingsPasswordNewPassword = 'SettingsPasswordNewPassword';
export const SettingsPasswordNewPasswordError = 'SettingsPasswordNewPasswordError';
export const SettingsPasswordSubmissionError = 'SettingsPasswordSubmissionError';
export const SettingsPastWins = 'SettingsPastWins';
export const SettingsPrizeClaimedHeader = 'SettingsPrizeClaimedHeader';
export const SettingsPrizeClaimedText = 'SettingsPrizeClaimedText';
export const SettingsProfileCity = 'SettingsProfileCity';
export const SettingsProfileCityError = 'SettingsProfileCityError';
export const SettingsProfileCountry = 'SettingsProfileCountry';
export const SettingsProfileCountryError = 'SettingsProfileCountryError';
export const SettingsProfileEmail = 'SettingsProfileEmail';
export const SettingsProfileEmailCollision = 'SettingsProfileEmailCollision';
export const SettingsProfileEmailError = 'SettingsProfileEmailError';
export const SettingsProfileFirstName = 'SettingsProfileFirstName';
export const SettingsProfileFirstNameError = 'SettingsProfileFirstNameError';
export const SettingsProfileLastName = 'SettingsProfileLastName';
export const SettingsProfileLastNameError = 'SettingsProfileLastNameError';
export const SettingsProfilePostalCode = 'SettingsProfilePostalCode';
export const SettingsProfilePostalCodeError = 'SettingsProfilePostalCodeError';
export const SettingsProfileProvince = 'SettingsProfileProvince';
export const SettingsProfileProvinceError = 'SettingsProfileProvinceError';
export const SettingsProfileStreetAddress = 'SettingsProfileStreetAddress';
export const SettingsProfileStreetAddressError = 'SettingsProfileStreetAddressError';
export const SettingsRegistrationDate = 'SettingsRegistrationDate';
export const SettingsRemovePicture = 'SettingsRemovePicture';
export const SettingsStatus = 'SettingsStatus';
export const SettingsTicketNumber = 'SettingsTicketNumber';
export const SettingsTicketsPurchased = 'SettingsTicketsPurchased';
export const SettingsTitle = 'SettingsTitle';
export const SettingsTotalSpent = 'SettingsTotalSpent';
export const SettingsUpdateButtonMessageFailed = 'SettingsUpdateButtonMessageFailed';
export const SettingsUpdateButtonMessageNeutral = 'SettingsUpdateButtonMessageNeutral';
export const SettingsUpdateButtonMessageSaved = 'SettingsUpdateButtonMessageSaved';
export const SettingsUpdateButtonMessageUpdating = 'SettingsUpdateButtonMessageUpdating';
export const SettingsUserBilling = 'SettingsUserBilling';
export const SettingsUserHistory = 'SettingsUserHistory';
export const SettingsUserManagePassword = 'SettingsUserManagePassword';
export const SettingsUserProfile = 'SettingsUserProfile';
export const SettingsUserSettings = 'SettingsUserSettings';
export const SettingsUserTitle = 'SettingsUserTitle';
export const SettingsUserUnsubButtonMessageFailed = 'SettingsUserUnsubButtonMessageFailed';
export const SettingsUserUnsubButtonMessageNeutral = 'SettingsUserUnsubButtonMessageNeutral';
export const SettingsUserUnsubButtonMessageSaved = 'SettingsUserUnsubButtonMessageSaved';
export const SettingsUserUnsubButtonMessageUpdating = 'SettingsUserUnsubButtonMessageUpdating';
export const SettingsUserUnsubConfirm = 'SettingsUserUnsubConfirm';
export const SettingsUserUnsubHeader = 'SettingsUserUnsubHeader';
export const SettingsUserUnsubReminder = 'SettingsUserUnsubReminder';
export const SettingsUserUnsubWeekly = 'SettingsUserUnsubWeekly';
export const SettingsUserWins = 'SettingsUserWins';
export const SettingsVerification = 'SettingsVerification';
export const SettingsWeeklyWinner = 'SettingsWeeklyWinner';
export const SettingsWinner = 'SettingsWinner';

// ── Share ───────────────────────────────────────────────────────
export const ShareFacebookText = 'ShareFacebookText';
export const ShareTwitterText = 'ShareTwitterText';

// ── Snackbar ───────────────────────────────────────────────────────
export const SnackbarCheckoutCheckout = 'SnackbarCheckoutCheckout';
export const SnackbarCheckoutPost = 'SnackbarCheckoutPost';
export const SnackbarCheckoutPre = 'SnackbarCheckoutPre';
export const SnackbarTicketsSold = 'SnackbarTicketsSold';

// ── TermsAndConditions ───────────────────────────────────────────────────────
export const TermsAndConditionsText = 'TermsAndConditionsText';
export const TermsAndConditionsTitle = 'TermsAndConditionsTitle';

// ── TestTag ───────────────────────────────────────────────────────
export const TestTag1 = 'TestTag1';
export const TestTag2 = 'TestTag2';

// ── Testing ───────────────────────────────────────────────────────
export const TestingEditor = 'TestingEditor';

// ── ThankYou ───────────────────────────────────────────────────────
export const ThankyouEnvelopeDisclaimer = 'ThankyouEnvelopeDisclaimer';

// ── Thankyou ───────────────────────────────────────────────────────
export const ThankyouAdditionalInformationTextTitle = 'ThankyouAdditionalInformationTextTitle';
export const ThankyouAnotherReceipt = 'ThankyouAnotherReceipt';
export const ThankyouContact = 'ThankyouContact';
export const ThankyouCost = 'ThankyouCost';
export const ThankyouDateText = 'ThankyouDateText';
export const ThankyouDrawDate = 'ThankyouDrawDate';
export const ThankyouDrawDateText = 'ThankyouDrawDateText';
export const ThankyouDrawInformation = 'ThankyouDrawInformation';
export const ThankyouEnvelope = 'ThankyouEnvelope';
export const ThankyouFacebook = 'ThankyouFacebook';
export const ThankyouLicenseText = 'ThankyouLicenseText';
export const ThankyouLicenseText1 = 'ThankyouLicenseText1';
export const ThankyouLicenseText2 = 'ThankyouLicenseText2';
export const ThankyouLocalLicenseText1 = 'ThankyouLocalLicenseText1';
export const ThankyouModifiedDate = 'ThankyouModifiedDate';
export const ThankyouOperatedBy = 'ThankyouOperatedBy';
export const ThankyouOperatingAddress = 'ThankyouOperatingAddress';
export const ThankyouOperatingOrgName = 'ThankyouOperatingOrgName';
export const ThankyouOptionsSelectedTitle = 'ThankyouOptionsSelectedTitle';
export const ThankyouPartnerText = 'ThankyouPartnerText';
export const ThankyouPayment = 'ThankyouPayment';
export const ThankyouPaymentPost = 'ThankyouPaymentPost';
export const ThankyouPDF = 'ThankyouPDF';
export const ThankyouPrint = 'ThankyouPrint';
export const ThankyouPrizeClaim = 'ThankyouPrizeClaim';
export const ThankyouReceiptDisclaimer = 'ThankyouReceiptDisclaimer';
export const ThankyouSendAnother = 'ThankyouSendAnother';
export const ThankyouShareText = 'ThankyouShareText';
export const ThankyouText = 'ThankyouText';
export const ThankyouTicketList = 'ThankyouTicketList';
export const ThankyouTicketNumber = 'ThankyouTicketNumber';
export const ThankyouTitle = 'ThankyouTitle';
export const ThankyouTo = 'ThankyouTo';
export const ThankyouTotal = 'ThankyouTotal';
export const ThankyouTwitter = 'ThankyouTwitter';
export const ThankyouUniqueId = 'ThankyouUniqueId';
export const ThankyouVoid = 'ThankyouVoid';
export const ThankyouWinnersPage = 'ThankyouWinnersPage';
export const ThankyouWinnersText = 'ThankyouWinnersText';

// ── Theme ───────────────────────────────────────────────────────
export const ThemeDarkText = 'ThemeDarkText';
export const ThemeLightText = 'ThemeLightText';

// ── SquareGame ──────────────────────────────────────────────────────
export const SqStandard_legendAvailable = 'SqStandard.legendAvailable';
export const SqStandard_legendTaken = 'SqStandard.legendTaken';
export const SqStandard_legendWinner = 'SqStandard.legendWinner';
export const SqStandard_step1Desc = 'SqStandard.step1Desc';
export const SqStandard_step1Title = 'SqStandard.step1Title';
export const SqStandard_step2Desc = 'SqStandard.step2Desc';
export const SqStandard_step2Title = 'SqStandard.step2Title';
export const SqStandard_step3Desc = 'SqStandard.step3Desc';
export const SqStandard_step3Title = 'SqStandard.step3Title';
export const SqStandard_step4Desc = 'SqStandard.step4Desc';
export const SqStandard_step4Title = 'SqStandard.step4Title';
export const SqStyle1_betterLuck = 'SqStyle1.betterLuck';
export const SqStyle1_drawResults = 'SqStyle1.drawResults';
export const SqStyle1_legendAvailable = 'SqStyle1.legendAvailable';
export const SqStyle1_legendTaken = 'SqStyle1.legendTaken';
export const SqStyle1_legendWinner = 'SqStyle1.legendWinner';
export const SqStyle1_missedOut = 'SqStyle1.missedOut';
export const SqStyle1_yourSquares = 'SqStyle1.yourSquares';

// ── SuperballBingo ─────────────────────────────────────────────────
export const SBStandard_ballsRemainingOf = 'SBStandard.ballsRemainingOf';
export const SBStandard_ofBalls = 'SBStandard.ofBalls';
export const SBStandard_sessionSalesPercent = 'SBStandard.sessionSalesPercent';
export const SBStandard_step1Desc = 'SBStandard.step1Desc';
export const SBStandard_step1Title = 'SBStandard.step1Title';
export const SBStandard_step2Desc = 'SBStandard.step2Desc';
export const SBStandard_step2Title = 'SBStandard.step2Title';
export const SBStandard_step3Desc = 'SBStandard.step3Desc';
export const SBStandard_step3Title = 'SBStandard.step3Title';
export const SBStandard_step4Desc = 'SBStandard.step4Desc';
export const SBStandard_step4Title = 'SBStandard.step4Title';
export const SBStandard_stepLabel = 'SBStandard.stepLabel';
export const SBStyle2_jackpotOdds = 'SBStyle2.jackpotOdds';
export const SBStyle2_sessionPrize = 'SBStyle2.sessionPrize';
export const SBStyle2_sessionSales = 'SBStyle2.sessionSales';
export const SBStyle2_ticketsSold = 'SBStyle2.ticketsSold';
export const SBStyle3_pricingText = 'SBStyle3.pricingText';

// ── Unsubscribe ───────────────────────────────────────────────────────
export const UnsubscribedResubscribe = 'UnsubscribedResubscribe';
export const UnsubscribedSubTitle = 'UnsubscribedSubTitle';
export const UnsubscribedText = 'UnsubscribedText';
export const UnsubscribedTitle = 'UnsubscribedTitle';
export const UnsubscribeResubscribe = 'UnsubscribeResubscribe';
export const UnsubscribeSubTitle = 'UnsubscribeSubTitle';
export const UnsubscribeText = 'UnsubscribeText';
export const UnsubscribeTitle = 'UnsubscribeTitle';

// ── Winners ───────────────────────────────────────────────────────
export const WinnersCopyNonWinner = 'WinnersCopyNonWinner';
export const WinnersCopyTicket = 'WinnersCopyTicket';
export const WinnersCopyWinner = 'WinnersCopyWinner';
export const WinnersCTAText = 'WinnersCTAText';
export const WinnersCTATitle = 'WinnersCTATitle';
export const WinnersCTATitlePost = 'WinnersCTATitlePost';
export const WinnersCTATitlePre = 'WinnersCTATitlePre';
export const WinnersGame = 'WinnersGame';
export const WinnersJackpotWinner = 'WinnersJackpotWinner';
export const WinnersLinkCopied = 'WinnersLinkCopied';
export const WinnersNavText = 'WinnersNavText';
export const WinnersText = 'WinnersText';
export const WinnersTitle = 'WinnersTitle';
export const WinnersWeek = 'WinnersWeek';
export const WinnersWeeklyWinner = 'WinnersWeeklyWinner';
